import axios from "axios";
import moment from "moment";

export const getParameterSettings = (organizationId, year) => {
  const requestUrl = `/team/organization_setting/get`;
  let params = {
    organization: organizationId,
    year: year ? year : moment().format("YYYY")
  };

  return axios.get(requestUrl, { params });
};

export const saveParameterSettings = (
  organization,
  year,
  synchro,
  synchroRole,
  synchroEntity,
  benchmarkValue,
  defaultAuthParameters,
  priceList
) => {
  const requestUrl = `/team/organization_setting/save`;
  var formData = new FormData();
  formData.append("organization", organization.id);
  formData.append("year", year ? year : moment().format("YYYY"));
  formData.append("synchro", synchro);
  formData.append("synchro_role", synchroRole);
  formData.append("synchro_entity", synchroEntity);
  benchmarkValue && formData.append("benchmark_value", benchmarkValue);
  defaultAuthParameters &&
    formData.append("auth_parameters", JSON.stringify(defaultAuthParameters));
  priceList && formData.append("price_list", JSON.stringify(priceList));
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/parameter-settings.js